import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _Entailment } from '../../../../core/services/dataBean/EntityCatalog';
import { _MarketPlaceCategory } from '../../../../core/services/dataBean/EntityCatalogVdos';

interface Props {
    idMarketPlace: any
    idSelector: number;
    onChange: any;
    label?: string;
}

export const MarketPlaceCategoryEditor = ({ idSelector, onChange, label, idMarketPlace }: Props) => {

    const markcat = useDataBean(_MarketPlaceCategory);
    const [lista, setLista] = useState<any[]>([]);
    const [id, setID] = useState<number>(idSelector);

    useEffect(() => {
        getLista();
    }, [idMarketPlace]);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
            ////console.log(idSelector)
        }
    }, [idSelector]);

    const setValue = (e: any) => {
        const selectedID = parseInt(e);
        onChange(selectedID);
    };

    const getLista = () => {
        markcat.instance.getMarketPlaceCategoryCatalog(idMarketPlace).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        );
    };

    return (
        <>
            <label>{label ?? "Categorías de Market:"}</label>
            <select className="form-select" value={id} onChange={(e) => setValue(e.target.value)}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => (
                        <option key={index} value={item.DataBeanProperties.IDMarketPlaceCategory}>
                            {item.DataBeanProperties.Name}
                        </option>
                    ))
                }
            </select>
        </>
    );
};
